// src/pages/SplashScreen.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import splashImage from "../../assets/splashScreen/Logo.svg" // your screenshot image

export function SplashStartScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/home"); 
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-full h-screen flex items-center justify-center bg-[#f8fafa]">
      <img
        src={splashImage}
        alt="Splash"
        className="w-[80%] max-w-[300px] mx-auto"
      />
    </div>
  );
}


export default SplashStartScreen
